import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from '@material-ui/core';
// Button MUI v4 usado diretamente em vez de ButtonUI: ButtonUI é sempre fullWidth+outlined,
// incompatível com botão de ação primária (variant="contained") e layout compacto de dialog.
import { ALERTA_AS_LABELS as LABELS } from './alertaCamposIncompletosDialog.constants';

export default function AlertaCamposIncompletosDialog({
  open,
  camposFaltantes = [],
  onCancelar = () => {},
  onContinuar = () => {},
}) {
  return (
    // disableBackdropClick + disableEscapeKeyDown: fechamento controlado pela saga via race()/take()
    <Dialog open={open} maxWidth="sm" fullWidth disableBackdropClick disableEscapeKeyDown>
      <DialogTitle>{LABELS.titulo}</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>{LABELS.mensagem}</Typography>
        <List dense disablePadding>
          {camposFaltantes.map(campo => (
            <ListItem key={campo.name} disableGutters>
              <Typography color="error">{campo.label}</Typography>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelar}>
          {LABELS.cancelar}
        </Button>
        <Button onClick={onContinuar} color="primary" variant="contained">
          {LABELS.continuar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
